import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StructureList } from '../shared/models/structure-list';
import { StructuredInfoListDto } from '../shared/dto/structured-info-list-dto';
import { catchError, map } from 'rxjs/operators';
import { StructureInfoFactory } from '../shared/helpers/structure-info.factory';
import { AppUrls } from '../route/app-urls';
import { HttpClient } from '@angular/common/http';
import { WebdokuService } from '../web-doku/webdoku.service';
import { ErrorHandlers } from '../shared/helpers/error-handlers';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  private http = inject(HttpClient);
  private webDokuService = inject(WebdokuService);

  public get(): Observable<StructureList> {
    //return of([])
    return this.http
      .get<StructuredInfoListDto>(
        AppUrls.getApiUrl(AppUrls.urlHistory, 'get') + '?webDokuId=' + this.webDokuService.currentWebDokuId
      )
      .pipe(
        //retry(this.maxRetries),   //ToDo: use retryWhen to avoid multiple calls on special errors, add delay
        map((dtoRaw) => {
          const converted = StructureInfoFactory.fromStructureDTOList(dtoRaw, this.webDokuService.currentWebDokuId);
          converted.isFlat = true;
          return converted;
        }),
        catchError((error) => {
          return ErrorHandlers.errorHandler(error);
        })
      );
  }

  public clear(): Observable<boolean> {
    return this.http
      .post<string>(
        AppUrls.getApiUrl(AppUrls.urlHistory, 'clear'),
        JSON.stringify(this.webDokuService.currentWebDokuId)
      )
      .pipe(
        map(() => true),
        catchError(() => {
          return of(false);
        })
      );
  }

  public openDocument(webDokuId: string, docId: string) {
    const data = {
      webDokuId: webDokuId,
      documentId: docId,
    };
    this.http.post<any>(AppUrls.getApiUrl(AppUrls.urlHistory, 'opened'), JSON.stringify(data)).pipe().subscribe();
  }
}
